import React, { ChangeEvent, useRef, useState } from "react";
import styles from "./fileUpload.module.css";
import Tooltip from "../tooltip/tooltip";
import { tWithKeyAttr as t } from "../../i18nHelper";

function FileUpload({
  onFileChange,
  onSendClick,
  showSendButton,
}: {
  onFileChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSendClick?: () => void;
  showSendButton?: boolean;
}) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <>
     <input
        type="file"
        multiple
        accept="
          image/png,
          image/jpeg,
          image/gif,
          application/pdf,
          application/msword,
          application/vnd.openxmlformats-officedocument.wordprocessingml.document,
          application/vnd.ms-excel,
          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        "
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={onFileChange}
      />
      <div
        className={styles.customFileUpload}
        onClick={handleClick}
        onDragOver={(e) => e.preventDefault()} // enable drop
        onDrop={(e) => {
          e.preventDefault();
          if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const fileList = e.dataTransfer.files;
            // Create a synthetic event to reuse your handleFileChange logic
            const syntheticEvent = {
              target: { files: fileList },
            } as unknown as ChangeEvent<HTMLInputElement>;
            onFileChange(syntheticEvent);
            e.dataTransfer.clearData();
          }
        }}
      >
        <button
          type={"button"}
          className={styles.uploadBtn}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <Tooltip isShown={showTooltip}>choose file</Tooltip>
        </button>
        <span>{t("YOU_CAN_DRAG_YOUR_FILE_HERE_OR_CLICK_TO_SELECT")}</span>
        {showSendButton && (
          <button
            type="button"
            data-testid="send-file-button"
            className={`${styles.button} ${styles.button_type_send}`}
            onClick={(e) => {
              e.stopPropagation(); 
              onSendClick?.();
            }}
          />
        )}
      </div>
    </>
  );
}

export default FileUpload;
